'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

var List = require('./list')

var ClientPresetsList = function () {

  //
  var API = {
    list: function (options) {
      var list = new List(options)
    }

  }

  App.globalChannel.on('client-presets:list', function (options) {
    API.list(options)
  })
}

module.exports = ClientPresetsList



// WEBPACK FOOTER //
// ./js/modules/client-presets/index.js